import { Trigger } from '@radix-ui/react-context-menu'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'

export interface ContextMenuTriggerProps extends ComponentPropsWithoutRef<
  typeof Trigger
> {
  asChild?: boolean
  disabled?: boolean
  /**
   * [data-state] -	"open" | "closed"
   */
  className?: string
  children: ReactNode
}

export const ContextMenuTrigger = Trigger
